<div class="col-12" *ngIf="gridLoaded && viewAccumulators">
    <kendo-grid [data]="viewAccumulators.gridData" [sortable]="true" [sort]="viewAccumulators.state.sort"
        [rowClass]="accumulatorRowCallback" [ngStyle]="{'max-height': gridMaxHeight}"
        (dataStateChange)="accumulatorDataStateChange($event)">
        <kendo-grid-messages noRecords="{{ 'NO-ACCUMULATORS' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-column field="accumulatorName" [width]="32" title="{{ 'ACCUMULATOR' | translate }}">
        </kendo-grid-column>
        <kendo-grid-column field="frequencyName" [width]="14" title="{{ 'FREQUENCY' | translate }}">
        </kendo-grid-column>
        <kendo-grid-column *ngIf="durationLoaded" field="duration" [width]="14" title="{{ 'DURATION' | translate }}"
            [class]="{ accumulatorDurationColumn: true }">
        </kendo-grid-column>
        <kendo-grid-column-group title="{{'MAXIMUM' | translate}}">
            <kendo-grid-column field="maxUnits" [width]="20" title="{{ 'UNITS' | translate }}" class="text-right">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.maxUnits !== null">{{dataItem.maxUnits}}</span>
                    <span *ngIf="dataItem.maxUnits === null">-</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="maxAmount" [width]="20" title="{{ 'AMOUNT' | translate }}" format="n2"
                class="text-right">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.maxAmount !== null">{{dataItem.maxAmount | number :
                        '1.2-2'}}</span>
                    <span *ngIf="dataItem.maxAmount === null">-</span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid-column-group>
        <kendo-grid-column-group title="{{newTitleKey | translate}}">
            <kendo-grid-column field="totalUnits" [width]="20" title="{{ 'UNITS' | translate }}"
                [class]="{ accumulatorUnitColumn: true }">
            </kendo-grid-column>
            <kendo-grid-column field="totalAmount" [width]="20" title="{{ 'AMOUNT' | translate }}"
                [class]="{ accumulatorAmountColumn: true }" format="n2">
            </kendo-grid-column>
        </kendo-grid-column-group>
        <kendo-grid-column-group title="{{'REMAINING-TOTAL' | translate}}">
            <kendo-grid-column field="remainingUnits" [width]="20" title="{{ 'UNITS' | translate }}"
                [class]="{ remainingUnitColumn: true }">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.remainingUnits !== null">{{dataItem.remainingUnits}}</span>
                    <span *ngIf="dataItem.remainingUnits === null">-</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="remainingAmount" [width]="20" title="{{ 'AMOUNT' | translate }}"
                [class]="{ remainingAmountColumn: true }" format="n2">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.remainingAmount !== null">{{dataItem.remainingAmount | number :
                        '1.2-2'}}</span>
                    <span *ngIf="dataItem.remainingAmount === null">-</span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid-column-group>
    </kendo-grid>
</div>